import { useContext } from 'react'
import { StateContext } from '../components/StateProvider'

export const useGlobalState = () => useContext(StateContext)
